
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import NgtFilmSelector from '@/components/NgtFilmSelector.vue';
import FileUploader from '@/components/FileUploader.vue';
import MultiSourceVideo from '@/repositories/data/MultiSourceVideo';

@Component({
    components: {
        NgtFilmSelector,
        FileUploader,
    },
})
export default class MultiSourceVideoSelector extends Vue {
    @Prop({ required: false, type: String, default: '' })
    public readonly id!: string;

    @Prop({ type: Array, required: false, default: () => [] })
    public readonly rules!: ((value: any) => string | boolean)[];

    @Prop({ required: false, type: String, default: '' })
    public readonly errorMessages!: string;

    @Prop({ required: false, type: String, default: '' })
    public readonly label!: string;

    @Prop({ type: String, required: true })
    private readonly i18nGroup!: string;

    @Prop({ required: false, type: Boolean, default: false })
    public readonly required!: boolean;

    @Prop({ required: false, type: Boolean, default: false })
    public readonly disabled!: boolean;

    public source = 'ngt';
    public innerValue: any = null;

    @Prop({ required: false, type: Object, default: null })
    private readonly value!: MultiSourceVideo | null;

    public created(): void {
        if (this.value) {
            if (this.value.ngtMediaReferenceId !== null) {
                this.source = 'ngt';
            } else if (this.value.cmsVideoReferenceId !== null) {
                this.source = 'upload';
            } else {
                this.source = 'url';
            }
        }
    }

    @Watch('innerValue')
    public onInnerValueChanged(value: any) {
        let result: MultiSourceVideo;
        if (this.source === 'ngt') {
            result = { ngtMediaReferenceId: value, cmsVideoReferenceId: null, urlVideoSource: null };
        } else if (this.source === 'upload') {
            result = { ngtMediaReferenceId: null, cmsVideoReferenceId: value, urlVideoSource: null };
        } else {
            result = { ngtMediaReferenceId: null, cmsVideoReferenceId: null, urlVideoSource: value };
        }
        this.$emit('input', result);
    }

    @Watch('source', { immediate: true })
    public onSourceChanged(source: any) {
        if (this.value) {
            if (source === 'ngt') {
                this.innerValue = this.value.ngtMediaReferenceId;
            } else if (source === 'upload') {
                this.innerValue = this.value.cmsVideoReferenceId;
            } else {
                this.innerValue = this.value.urlVideoSource;
            }
        } else {
            this.innerValue = null;
        }
    }

    public get sourceSelectOptions() {
        return [
            {
                key: 'ngt',
                label: this.$t('multiSourceVideo.sources.ngt').toString(),
            },
            {
                key: 'upload',
                label: this.$t('multiSourceVideo.sources.upload').toString(),
            },
            {
                key: 'url',
                label: this.$t('multiSourceVideo.sources.url').toString(),
            },
        ];
    }
}
